import { useRef } from 'react';

interface UploadHubSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

const UploadHubSearchBar = (props: UploadHubSearchBarProps) => {
  const { value, onChange } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className='d-none d-lg-flex border rounded-pill bg-main-white general-button specific-x-padding-12 specific-y-padding-3 flex-centered upload-hub-searchbar'>
      <span className='icon-search light-50-text mr-2' />
      <input
        ref={inputRef}
        className='input-empty paragraph-p1'
        type='text'
        placeholder='Search files'
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <div className='close-icon-container' style={{ visibility: value !== '' ? 'visible' : 'hidden' }}>
        <button
          type='button'
          className='general-button close-icon'
          onClick={() => {
            onChange('');
            inputRef.current?.focus();
          }}
        />
      </div>
    </div>
  );
};

export default UploadHubSearchBar;
